import { Stack } from '@/components/layout';
import { Button } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import type { FamilyEvent } from '@/features/guardian/family-events';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

const strings = STRINGS.guardian.kids.eventDetail;

type EventDetailActionsProps = {
  event: FamilyEvent;
  onReschedule?: () => void;
  onViewBooking?: () => void;
};

export function EventDetailActions({
  event,
  onReschedule,
  onViewBooking,
}: EventDetailActionsProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack gap={scale(8)}>
      {event.canReschedule ? (
        <Button variant="outline" onPress={onReschedule} style={styles.button}>
          <Button.Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold">
            {strings.reschedule}
          </Button.Text>
        </Button>
      ) : null}
      <Button onPress={onViewBooking} style={[styles.button, styles.primaryButton]}>
        <Button.Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold">
          {strings.viewBooking}
        </Button.Text>
        <Button.Icon name="IcArrowRight" position="right" size={scale(20)} color={colors['0']} />
      </Button>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  button: {
    minHeight: scale(48),
    borderRadius: scale(12),
    borderCurve: 'continuous',
  },
  primaryButton: {
    backgroundColor: guardianColors['Main/Main'],
  },
}));
